import { createContext } from 'react';
import { EventName } from '../types/events';
import { UnifiedEventParams } from '../tracking/types/event-types';

// Type for initialization state
export interface InitState {
    supabase: boolean;
    ga4: boolean;
    fb: boolean;
    cf: boolean;
    gtmReady?: boolean;
    initialized?: boolean;
    systemReady?: boolean;
}

// Type for GTM context value
export interface GTMContextValue {
    pushEvent: (
        eventName: EventName,
        data?: {
            eventParams?: UnifiedEventParams['eventParams'];
            userParams?: {
                user_id?: string;
                email?: string;
                phone?: string;
                first_name?: string;
                last_name?: string;
                city?: string;
                region?: string;
                postal_code?: string;
                country?: string;
            };
            [key: string]: unknown;
        }
    ) => void;
    initState: InitState;
}

// Create context with default value to avoid empty object type errors
export const GTMContext = createContext<GTMContextValue>({
    pushEvent: () => {}, // No-op default implementation
    initState: {
        supabase: false,
        ga4: false,
        fb: false,
        cf: false,
        systemReady: false
    }
});
